const hasAllSelected = (samplesSelected, id) =>
  Object.keys(samplesSelected).every(e => samplesSelected[e].includes(id));

export default hasAllSelected;
